import React from 'react';
import { TitleHierarchyComponent } from '@tmt-insights/oms_fe_core';
import { Typography } from '@tmt-insights/oms_fe_core/material';
import { getLineageMetaTitle } from '@tmt-insights/oms_fe_core/utils';

const TitleHierarchy: TitleHierarchyComponent = ({ title, nameFallback }) => {
  const lineageMetaTitle = getLineageMetaTitle(title, true);
  return (
    <div>
      <Typography>
        <strong>{lineageMetaTitle || title.name || nameFallback}</strong>
      </Typography>
      {!!title.children?.length && !!lineageMetaTitle && (
        <Typography variant="caption" sx={{ lineHeight: 1.9, fontSize: '.9rem' }}>
          {title.name || nameFallback}
        </Typography>
      )}
    </div>
  );
};

export default TitleHierarchy;
